import React, { useEffect, useState } from "react";
import AvatarName from "../../UniversalComponents/AvatarName";
import OrganisationBg from "../assets/final.webp";
import { ReactComponent as TimeIcon } from "../assets/TimeIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { LaunchOrg } from "../../../utils/constants";
import { getOrganizations, getUserId, getUserToken } from "../../../utils/utilityFunctions/localServices";
import { addParticularCompany, addUser, addUserCompanyAccess, updateUser } from "../../../utils/userSlice";
import { useDispatch } from "react-redux";
import { useLazyFetchCompanyPermissionsQuery } from "../../../utils/customer/customerTable";
// import { ReactComponent as Onboarding } from "../assets/Grapic_Bg.svg";
import { ReactComponent as Onboarding } from "../assets/Grapic_Bg.svg";
import Button from "../../UniversalComponents/DefaultButton";

import { ReactComponent as OrganizationBg } from "../assets/OrganizationBg.svg";

const Workspaces = () => {
  const location = useLocation();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const workspaces = getOrganizations() || location?.state?.workspaces || [];

  const getFirstWordInitial = (name) => {
    if (!name) return "";
    return name.trim().split(" ")[0][0].toUpperCase();
  };

  //company permission api
  const [fetchCompanyPermissions, { data: companyPermissionsData, isSuccess: companyPermissionsSuccess }] =
    useLazyFetchCompanyPermissionsQuery();

  const updateAndNagivate = async () => {
    dispatch(addUserCompanyAccess(companyPermissionsData?.data));

    navigate("/customers");
  };

  useEffect(() => {
    if (companyPermissionsData && companyPermissionsData?.data) updateAndNagivate();
  }, [companyPermissionsData, companyPermissionsSuccess]);

  const handleSelectWorkspace = async (workspaceId) => {
    // Logic to handle workspace selection, e.g., navigate to the selected workspace

    try {
      const response = await fetch(`${LaunchOrg}?org_id=${workspaceId}`, {
        method: "POST",
        // body: '',
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          // "Content-Type": "application/json",
        },
      });

      const res = await response.json();

      if (!res.success) {
        // setErrorMessage({ apiError: res.error || "Invalid credentials. Please try again." });
        return;
      }

      console.log("LaunchOrg response:", res);
      const data = res?.data;

      dispatch(
        addParticularCompany({
          company_id: data?.company?.id,
          company_name: data?.company?.company_name,
          company_logo: data?.company?.company_logo,
          menuName: "",
        })
      );

      if (data.user_id !== getUserId()) localStorage.removeItem("saved_view");

      dispatch(addUser(data));
      localStorage.setItem("ownerInfo", JSON.stringify({ isOwner: Boolean(data.super_admin) }));

      if (data?.company_set === 1) {
        dispatch(updateUser(data));
      }
      // if(data.workspaces && data.workspaces.length>1){
      //   navigate("/workspaces" , { state: { workspaces: data.workspaces } });
      // }else{

      const DataAwait = await fetchCompanyPermissions({ token: getUserToken(), companyId: data?.company.id });
      // }
    } catch (error) {
      console.error("Login Error:", error);
      // setErrorMessage("Something went wrong. Please try again later.");
    }
  };

  return (
    <main className="relative min-h-screen w-full flex items-center justify-center">
      <div className="absolute inset-0 z-0 ">
        {/* <img src={OrganisationBg} className="w-full h-full object-cover bg-primary" /> */}
        <Onboarding className="absolute bg-primary  w-full h-full object-cover " />
      </div>

      {/* Main Content */}
      <section className="w-fit min-h-[500px] max-h-[500px] flex flex-col px-6 py-6 font-Inter relative z-10 rounded-lg border border-white bg-[#ffffffbf] shadow-[2px_3px_20px_0_rgba(0,0,0,0.15)]">
        <h2 className="text-[24px] font-semibold text-primary text-center pb-4">Select Organization</h2>

        <div className="flex flex-col gap-3 min-h-0 grow overflow-y-auto">
          {workspaces?.map((workspace) => {
            const initials = getFirstWordInitial(workspace.org_name);

            return (
              <div
                key={workspace.id}
                className="flex items-center min-h-fit justify-between gap-2 py-4 px-4 overflow-hidden cursor-pointer transition border-b border-dashed border-[#1d446980] hover:border-transparent hover:bg-[#fff] group hover:rounded-md"
              >
                <div className="flex items-center gap-3 text-primary">
                  <AvatarName
                    name={initials}
                    size="large"
                    bgColor="#ffffff"
                    textColor="#1D4469"
                    borderColor="#C3DFFA"
                  />
                  <div className="flex flex-col">
                    <span className="text-[20px] font-medium text-primary">{workspace.org_name}</span>
                    <span className="text-sm font-normal flex items-center gap-1">
                      <TimeIcon />
                      <span className="text-[#1a1a1a99]">Last logged on:</span> <span className="text-[#1A1A1A]"></span>
                      {workspace.last_logged ? workspace.last_logged : "Never"}
                    </span>
                  </div>
                </div>

                <Button
                  className="px-4 py-1 text-base font-medium border text-primary border-[#D2DAE1] rounded-md bg-[#F1F6F9] hover:border-primary hover:text-white hover:bg-primary opacity-0 group-hover:opacity-100 transition-opacity"
                  variant="secondary"
                  onClick={() => handleSelectWorkspace(workspace.org_id)}
                >
                  Launch
                </Button>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default Workspaces;
